const Footer = ()=>{
    return(
        <>
            <footer>
                <div className="contact">
                            jeronimo24perez@gmail.com
                </div>
                <div className="info">
                    Esta es una pagina creada por Jeronimo Perez, es una pagina sobre la saga star wars, que abarca algunas historias como comics de la saga, videojuegos y biografias sobre personajes del universo star wars.<br/><br/>

                    esta pagina fue creada principalmente usando la libreria de React
                </div>
            </footer>
        </>
    )
}

export default Footer